export const teamFunctions = {
    methods: {
        getNextActivationDateTime(startTime, endTime) {
            const startDateTime = moment(moment().format('YYYY-MM-DD') + ' ' + startTime, 'YYYY-MM-DD HH:mm');
            let endDateTime = moment(moment().format('YYYY-MM-DD') + ' ' + endTime, 'YYYY-MM-DD HH:mm')
            // IF the end date time is before the start datetime: this means the end time should be the next day.
            // for example start at 23:00 end at 07:00
            if (endDateTime.isBefore(startDateTime)) {
                endDateTime = endDateTime.add(1, 'day');
            }
            const currentTime = moment();
            if (currentTime.isBefore(startDateTime)) {
                return startDateTime.toDate();
            } else {
                return startDateTime.add(1, 'day').toDate()
            }
        },
        getDeactivationDateTime(startTime, endTime) {
            const startDateTime = moment(moment().format('YYYY-MM-DD') + ' ' + startTime, 'YYYY-MM-DD HH:mm');
            let endDateTime = moment(moment().format('YYYY-MM-DD') + ' ' + endTime, 'YYYY-MM-DD HH:mm')
            // IF the end date time is before the start datetime: this means the end time should be the next day.
            // for example start at 23:00 end at 07:00
            if (endDateTime.isBefore(startDateTime)) {
                endDateTime = endDateTime.add(1, 'day');
            }
            return endDateTime.toDate();
        }
    }
};
